import GroupA from "@src/ruix/components/atoms/groups/GroupA";
import NumberA from "@src/ruix/components/atoms/numbers/NumberA";
import TitleA from "@src/ruix/components/molecules/Titles/TitleA";
import { TitleWithNumbersProps } from "@src/ruix/types";

const TitleWithNumbers = ({ title, number, desc }: TitleWithNumbersProps) => (
	<TitleA
		subTitle={desc}
		title={
			<GroupA order="row-center-start" gap={6}>
				<NumberA size="small" number={number}></NumberA>
				<div>{title}</div>
			</GroupA>
		}
		color="var(--card-bg)"
		size="small"
	></TitleA>
);

export default TitleWithNumbers;
